<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="8" lg="6" xl="4">
        <v-card>
          <v-container>
            <v-card-text class="font-weight-bold title text-center">기본 정보</v-card-text>
            <v-divider></v-divider>
            <br />
            <v-text-fi
              v-model="name"
              :value="name"
              :rules="nameRules"
              :success="nameSuccess"
              label="이름*"
              prepend-icon="mdi-account"
              hide-details
              class="mb-5"
            ></v-text-fi>
            <v-text-field
              v-model="email"
              :value="email"
              :rules="emailRules"
              :success="emailSuccess"
              label="이메일*"
              type="email"
              required
              prepend-icon="mdi-email"
              hide-details
              class="mb-5"
            ></v-text-field>
            <v-text-field
              v-model="phone"
              :rules="phoneRules"
              :success="phoneSuccess"
              label="전화번호*"
              type="text"
              required
              @keyup="onPhoneKeyup"
              prepend-icon="mdi-cellphone-android"
            ></v-text-field>

            <v-checkbox
              v-model="term"
              label="마케팅 정보 동의 (선택)"
              hide-details
              class="px-2 mt-1"
              color="primary"
            ></v-checkbox>
            <p class="caption px-4 pb-2 mt-0 md-0">* 거주지역 부동산 정보를 받아볼 수 있습니다.</p>
            <v-divider></v-divider>
            <subscription-component></subscription-component>
            <v-divider></v-divider>
            <v-row>
              <v-col justify="center" align="center">
                <v-btn class="primary" @click="onUpdateClick" align="center">저장하기</v-btn>
              </v-col>
              <div style="position:relative">
                <v-btn
                  text
                  @click="withdrawClick"
                  style="position:absolute;right:0;bottom:0;margin-right:10px;font-size:12px;color:gray"
                >회원탈퇴</v-btn>
              </div>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { api } from "../mixins/api.js";
import { formUtility } from "../mixins/formUtility.js";
import SubscriptionComponent from "./SubscriptionComponent";
import { mapMutations } from "vuex";

export default {
  async created() {
    await this.getProfile();
  },
  computed: {
    nameSuccess() {
      return this.validName(this.name);
    },
    emailSuccess() {
      return this.validEmail(this.email);
    },
    phoneSuccess() {
      return this.phone.length === 13;
    },
    fromSuccess() {
      return this.from.length !== null;
    }
  },
  data() {
    return {
      profile: null,
      name: "",
      nameRules: [
        v => !(v === "") || "이름은 필수입니다.",
        v => this.validName(v) || "잘못된 이름입니다."
      ],
      email: "",
      emailRules: [
        v => !(v === "") || "이메일은 필수입니다.",
        v => this.validEmail(v) || "잘못된 이메일 형식입니다."
      ],
      phone: "",
      phoneRules: [
        v => !(v === "") || "전화번호는 필수입니다.",
        v => v.length === 13
      ],
      from: "",
      fromRules: [
        v => !(v === "") || "가입경로는 필수입니다.",
        v => v.length > 0
      ],
      term: "false"
    };
  },
  methods: {
    ...mapMutations(["logout"]),
    async getProfile() {
      const profile = await api.methods.getProfileApi();
      this.profile = profile;
      this.name = this.profile.name;
      this.email = this.profile.email;
      this.phone = this.profile.phone;
      this.from = this.profile.referer;
      this.term = this.profile.isTermAgreed;

      this.onPhoneKeyup();
    },
    validName(v) {
      return /^[가-힣]{2,4}|^[a-zA-Z]{2,10}$|^[a-zA-Z]{2,10}\s[a-zA-Z]{2,10}$/.test(
        v
      );
    },
    validEmail(v) {
      return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        v
      );
    },
    onPhoneKeyup() {
      this.phone = this.getPhoneMask(this.phone);
    },
    async withdrawClick() {
      if (
        confirm(
          "회원 탈퇴 시 기존에 결제한 서비스를 이용할 수 없습니다.\n탈퇴하시겠습니까?"
        )
      ) {
        const result = await api.methods.withdrawApi();
        if (result) {
          alert("정상적으로 회원 탈퇴 되었습니다.");
          this.logout();
          this.$router.replace("/");
        } else {
          alert(
            "회원 탈퇴에 실패 하였습니다.\n고객 센터를 통해 문의 주시기 바랍니다."
          );
        }
      }
    },
    async onUpdateClick() {
      if (this.nameSuccess === false) {
        alert("이름을 올바르게 입력하세요");
        return;
      } else if (this.emailSuccess === false) {
        alert("이메일이 올바르게 입력하세요.");
        return;
      } else if (this.phoneSuccess === false) {
        alert("전화번호를 올바르게 입력하세요.");
        return;
      } else if (this.fromSuccess === false) {
        alert("가입경로를 올바르게 입력하세요.");
        return;
      }

      const response = await api.methods.updateProfileApi({
        referer: this.from,
        name: this.name,
        email: this.email,
        phone: this.phone.replace(/[^0-9]/g, ""),
        isTermAgreed: this.term === true ? 1 : 0
      });
      if (response === null) {
        alert("업데이트 실패");
      } else {
        alert("저장 되었습니다.");
      }
    }
  },
  mixins: [formUtility],
  components: {
    SubscriptionComponent
  }
};
</script>
